import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { IStoreState } from 'src/entity/StateEntity';
import { RouterConfig } from './urlConfig';

interface IPrimaryRouteProps extends RouteProps {
  isLogin: boolean;
}

class PrimaryRoute extends React.Component<IPrimaryRouteProps> {
  constructor(props: IPrimaryRouteProps) {
    super(props);
  }

  render() {
    const { isLogin, ...rest } = this.props;
    return (
      // <Route {...rest} render={props => {
      //     // if (pending) {
      //     //     return <div>Loading...</div>
      //     // }
      //     return !!isLogin ? <React.Component {...props} /> : <Redirect to={RouterConfig.Urls.login} />
      // }} />
      !!isLogin ? <Route {...rest} /> : <Redirect to={RouterConfig.Urls.login} />
    );
  }
}

// export default PrimaryRoute;

const mapStateToProps = ({ authState: { isLogin } }: IStoreState) => ({
  isLogin,
});
export default connect(mapStateToProps)(PrimaryRoute);



// WEBPACK FOOTER //
// ./src/routers/PrimaryRoute.tsx